import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { DropdownDivider } from 'foundations-components/transitional/components/Dropdown';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Link } from 'foundations-components/transitional/components/Link';
import { Small } from 'foundations-components/transitional/components/Small';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { PRODUCT_OVERVIEW_CARD_SECTION } from '../layout/cards/ProductOverviewCard';
import { getWorkflowEnrollmentKBArticle } from '../utils/DetailsPageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const borderStyles = {
  borderColor: 'border-core-subtle',
  borderStyle: 'solid',
  borderWidth: '100'
};
function VerticalDivider() {
  return /*#__PURE__*/_jsx(View, Object.assign({}, borderStyles, {
    borderInlineEndStyle: "none",
    justifySelf: "center",
    inlineSize: "0",
    paddingBlock: "200"
  }));
}
function TemplateStepCard(_ref) {
  let {
      children
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(View, Object.assign({
    borderRadius: "300"
  }, borderStyles, {
    paddingInline: "400",
    paddingBlock: "200"
  }, otherProps, {
    children: children
  }));
}
export function WorkflowTemplatePreview({
  enrollmentTrigger,
  firstAction,
  secondAction,
  totalActions = 0
}) {
  const {
    trackInteraction
  } = useDetailsPageContext();
  const workflowKBArticle = getWorkflowEnrollmentKBArticle();
  const remainingActions = totalActions - (firstAction ? 1 : 0) - (secondAction ? 1 : 0);
  function onClickTemplateTooltipLink() {
    trackInteraction({
      section: PRODUCT_OVERVIEW_CARD_SECTION,
      action: 'click template tooltip link'
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(Flex, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(Small, {
        marginInline: "auto",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `detailsPage.overviewCard.template.description.${totalActions === 0 ? 'none' : totalActions === 1 ? 'one' : 'other'}`,
          options: {
            count: totalActions
          }
        })
      })
    }), /*#__PURE__*/_jsxs(TemplateStepCard, {
      children: [/*#__PURE__*/_jsxs(Text, {
        as: "label",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.overviewCard.template.trigger"
        }), /*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "detailsPage.overviewCard.template.tooltip_jsx",
            elements: {
              Link
            },
            options: {
              external: true,
              href: workflowKBArticle,
              onClick: onClickTemplateTooltipLink
            }
          }),
          children: /*#__PURE__*/_jsx(IconHolder, {
            icon: InfoIcon
          })
        })]
      }), /*#__PURE__*/_jsx(Text, {
        children: enrollmentTrigger
      })]
    }), firstAction && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(VerticalDivider, {}), /*#__PURE__*/_jsx(TemplateStepCard, {
        flexDirection: "column",
        paddingInline: "400",
        paddingBlock: "200",
        children: /*#__PURE__*/_jsx(Text, {
          children: firstAction
        })
      })]
    }), secondAction && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(VerticalDivider, {}), /*#__PURE__*/_jsx(TemplateStepCard, {
        flexDirection: "column",
        paddingInline: "400",
        paddingBlock: "200",
        children: /*#__PURE__*/_jsx(Text, {
          children: secondAction
        })
      })]
    }), remainingActions > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(VerticalDivider, {}), /*#__PURE__*/_jsx(TemplateStepCard, {
        flexDirection: "column",
        paddingInline: "400",
        paddingBlock: "200",
        inlineSize: "fit-content",
        justifySelf: "center",
        children: /*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `detailsPage.overviewCard.template.nMoreSteps.${remainingActions === 1 ? 'one' : 'other'}`,
            options: {
              count: remainingActions
            }
          })
        })
      })]
    }), /*#__PURE__*/_jsx(DropdownDivider, {
      marginBlock: "300"
    })]
  });
}